<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card no-body>
      <!-- Header -->
      <b-card-header>
        <div
          v-if="hasObjectData"
          class="d-flex align-items-center"
        >
          <!-- Ícono -->
          <b-avatar
            variant="success"
            class="mr-50 badge-minimal"
          >
            <span class="d-flex align-items-center">
              <feather-icon
                icon="LayersIcon"
                size="20"
              />
            </span>
          </b-avatar>
          <!-- Datos de quien ingreso información -->
          <span class="mb-0">
            Datos capturados por el funcionario <b class="text-primary">{{ datosFuncionario.nombre }}</b> con correo <b class="text-primary">{{ datosFuncionario.email }}</b>:
          </span>
        </div>
      </b-card-header>

      <detalle-sugerencia :data="nuevaDependencia" />

      <!-- Botones -->
      <div :style="`padding: ${hasObjectData ? '2rem' : '1.5rem'}`">
        <b-row v-if="hasObjectData">
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="primary"
              @click="validate()"
            >
              <feather-icon
                icon="ThumbsUpIcon"
                class="mr-50"
              />
              <span class="align-middle">Validar y asignar información</span>
            </b-button>
          </b-col>
          <!-- <b-col md="6">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="danger"
              @click="refuse()"
            >
              <feather-icon
                icon="ThumbsDownIcon"
                class="mr-50"
              />
              <span class="align-middle">Declinar</span>
            </b-button>
          </b-col> -->
        </b-row>
      </div>

    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BAvatar,
  BRow,
  BCol,
  BOverlay,
  BButton,
} from 'bootstrap-vue'
import { useRouter, isObject, isEmptyObject } from '@core/utils/utils'
import { ref, onMounted, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DetalleSugerencia from './components/DetalleSugerencia.vue'
import { getDependenciaJSONData } from '../../useServicioEscolar'

export default {
  components: {
    BCard,
    BCardHeader,
    BAvatar,
    BRow,
    BCol,
    BOverlay,
    BButton,
    DetalleSugerencia,
  },
  directives: {
    Ripple,
  },
  setup(ctx, { emit }) {
    const toast = useToast()
    const { route } = useRouter() //* Use router propieties
    const { id } = route.value.params //* Get the token from params
    const loader = ref(false)
    const datosFuncionario = ref({})
    const nuevaDependencia = ref({})

    //* Comuted to know if the object isn't empty
    const hasObjectData = computed(() => !isEmptyObject(nuevaDependencia.value) && isObject(nuevaDependencia.value))

    //* Load data
    const fillData = () => {
      loader.value = true
      getDependenciaJSONData(id).then(response => {
        loader.value = false
        datosFuncionario.value = { nombre: response.nombre, email: response.email }
        nuevaDependencia.value = response.dependencia_json
        emit('set-data', nuevaDependencia.value)
      }, error => {
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de dependencia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Success copied
    const onCopy = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Texto copiado',
          icon: 'CopyIcon',
          variant: 'dark',
        },
      })
    }

    //* Error on copy
    const onError = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error al copiar texto',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    }

    //* Validate info sended by student
    const validate = () => {
      // TODO Se guarda información de dependencia en todas sus tablas correspondientes
      // TODO Se asignan id's a pre_registro
    }

    //* Refuse info sended by student
    const refuse = () => {
      // TODO Se habilita formulario de edición/alta
      // TODO Se realiza búsqueda de Dependencia a través de su RFC, si hay se muestran los datos y se pone leyenda de info encontrada, sino, se precargan datos de JSON
      // TODO Habilitar botón para asignar dependencia a pre_registro
    }

    onMounted(() => {
      fillData()
    })

    return {
      datosFuncionario,
      nuevaDependencia,

      // Methods
      onCopy,
      onError,
      validate,
      refuse,

      // Filters
      hasObjectData,

      // Loader
      loader,
    }
  },
}
</script>
